import * as l from "react";
const a = (e) => /* @__PURE__ */ l.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19.421 10.986h1.59a1 1 0 00.7-1.7l-7-7a1 1 0 00-1.7.7v1.59l-4.41 4.41h-2.59a1 1 0 00-.7.3l-1 1a1 1 0 000 1.4l2.912 2.912-4.972 5.738h.01l-.004.005a1.112 1.112 0 00-.006.006c-.376.437-.291.949 0 1.285a1.7 1.7 0 00.01.011c.33.371.914.52 1.4.103L9.4 16.773l2.912 2.913a1 1 0 001.4 0l1-1a1 1 0 00.3-.7v-2.59l4.41-4.41zm-6.41 6.571v-2.99l5.577-5.576-3.582-3.582-5.576 5.577H6.44l3.056 3.056 3.515 3.515z",
      fill: "#2d6ded"
    }
  )
), t = a;
export {
  t as default
};
